import { GraduationCap, Lightbulb } from "lucide-react";

const TIPS = [
  { title: "Front-load your savings", body: "Your first Student Finance payment feels huge. Move a chunk aside in September so December doesn't hurt." },
  { title: "Budget per week, not per term", body: "A weekly number is far easier to stick to than a big termly lump sum." },
  { title: "Name your one-offs early", body: "Christmas, birthdays and course trips are predictable. Plan them now, not the week before." },
  { title: "Track the small stuff", body: "Coffees, takeaways and subscriptions quietly add up to more than most students expect." },
];

export default function Tips() {
  return (
    <section className="mt-10" data-testid="tips-section">
      <div className="overflow-hidden rounded-3xl border border-[#E8EAEF] bg-white shadow-[0_4px_20px_rgba(0,0,0,0.03)]">
        <div className="grid md:grid-cols-2">
          <div className="relative min-h-[220px]">
            <img
              src="https://images.unsplash.com/photo-1758270704534-fd9715bffc0e"
              alt="Students in a lecture hall"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/50 to-transparent" />
            <div className="absolute bottom-5 left-5 flex items-center gap-2 text-white">
              <GraduationCap size={20} />
              <span className="font-display text-lg font-semibold">Money tips for students</span>
            </div>
          </div>
          <div className="p-6 sm:p-8">
            <div className="mb-4 flex items-center gap-2 text-[#734FFC]">
              <Lightbulb size={18} />
              <span className="text-sm font-semibold uppercase tracking-wide">Stay on track</span>
            </div>
            <ul className="space-y-4">
              {TIPS.map((t) => (
                <li key={t.title}>
                  <p className="font-display text-base font-semibold text-[#1A1A1A]">{t.title}</p>
                  <p className="text-sm text-[#747D89]">{t.body}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
